/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAdminUserPointsDetailPageListRespVo } from './GetAdminUserPointsDetailPageListRespVo';
import {
    GetAdminUserPointsDetailPageListRespVoFromJSON,
    GetAdminUserPointsDetailPageListRespVoFromJSONTyped,
    GetAdminUserPointsDetailPageListRespVoToJSON,
    GetAdminUserPointsDetailPageListRespVoToJSONTyped,
} from './GetAdminUserPointsDetailPageListRespVo';

/**
 * 
 * @export
 * @interface PageDataGetAdminUserPointsDetailPageListRespVo
 */
export interface PageDataGetAdminUserPointsDetailPageListRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataGetAdminUserPointsDetailPageListRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataGetAdminUserPointsDetailPageListRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataGetAdminUserPointsDetailPageListRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<GetAdminUserPointsDetailPageListRespVo>}
     * @memberof PageDataGetAdminUserPointsDetailPageListRespVo
     */
    records?: Array<GetAdminUserPointsDetailPageListRespVo>;
}

/**
 * Check if a given object implements the PageDataGetAdminUserPointsDetailPageListRespVo interface.
 */
export function instanceOfPageDataGetAdminUserPointsDetailPageListRespVo(value: object): value is PageDataGetAdminUserPointsDetailPageListRespVo {
    return true;
}

export function PageDataGetAdminUserPointsDetailPageListRespVoFromJSON(json: any): PageDataGetAdminUserPointsDetailPageListRespVo {
    return PageDataGetAdminUserPointsDetailPageListRespVoFromJSONTyped(json, false);
}

export function PageDataGetAdminUserPointsDetailPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataGetAdminUserPointsDetailPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(GetAdminUserPointsDetailPageListRespVoFromJSON)),
    };
}

export function PageDataGetAdminUserPointsDetailPageListRespVoToJSON(json: any): PageDataGetAdminUserPointsDetailPageListRespVo {
    return PageDataGetAdminUserPointsDetailPageListRespVoToJSONTyped(json, false);
}

export function PageDataGetAdminUserPointsDetailPageListRespVoToJSONTyped(value?: PageDataGetAdminUserPointsDetailPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(GetAdminUserPointsDetailPageListRespVoToJSON)),
    };
}

